import { z } from 'zod';
import { BaseApplicationDTOSchema, } from "./applications.dto.js";
import { SimulateApplicationOutputDTOSchema } from "./simulate-application.dto.js";
// Schema for input validation when creating an application. The optional
// `simulation` carries the installment option the patient chose, persisted as a
// snapshot so loan terms can be displayed before a Proposal exists.
export const CreateApplicationInputDTOSchema = BaseApplicationDTOSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    isDeleted: true,
    status: true,
    celcoinApplicationId: true,
    handoffReleasedAt: true,
}).extend({
    simulation: SimulateApplicationOutputDTOSchema.optional(),
});
// Request and response schemas for the API layer
export const CreateApplicationRequestDTOSchema = z.object({
    body: CreateApplicationInputDTOSchema.omit({
        companyId: true,
        facilityId: true,
    }),
    params: z.object({
        companyId: CreateApplicationInputDTOSchema.shape.companyId,
        facilityId: CreateApplicationInputDTOSchema.shape.facilityId,
    }),
});
//# sourceMappingURL=create-application.dto.js.map